import React, { useEffect } from 'react';
import {
  Form,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import './CancelExpenseClaimModal.scss';
import { initialValues, validationSchema } from './constants';

function CancelExpenseClaimModal({
  isOpen,
  toggle,
  handleOnSubmit,
  isLoading,
}) {
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  const onSubmit = async values => {
    const payload = {
      cancelReason: values.reason,
    };
    await handleOnSubmit(payload);
  };

  // always reset when modal opens
  useEffect(() => {
    if (isOpen) {
      reset(initialValues);
    }
  }, [isOpen, reset]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="s">
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="d-flex flex-column gap-3"
      >
        <ModalBody>
          <div>
            <h5>Confirmation</h5>
            <p>Are you sure you want to cancel this expense claim?</p>
          </div>
          <Label>
            Reason<span className="text-danger">*</span>
          </Label>
          <Controller
            control={control}
            name="reason"
            render={({ field }) => (
              <Input
                {...field}
                type="textarea"
                className={`form-control ${errors.reason ? 'is-invalid' : ''}`}
                placeholder="Enter Reason"
                rows="4"
              />
            )}
          />
          {errors.reason && (
            <div className="invalid-feedback">{errors.reason.message}</div>
          )}
        </ModalBody>
        <ModalFooter>
          <Col>
            <button
              type="button"
              onClick={toggle}
              className="tr-cancel-btn w-100"
            >
              No
            </button>
          </Col>
          <Col>
            <button
              onClick={handleSubmit(onSubmit)}
              type="button"
              className="tr-confirm-btn w-100"
              disabled={!isValid || isLoading}
            >
              {isLoading ? 'Cancelling...' : 'Yes, Cancel'}
            </button>
          </Col>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default CancelExpenseClaimModal;
